import React from 'react';

const AuthContext = React.createContext('login:false');

export default AuthContext;
